import { useEffect } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { MeResponse, ProductKeys } from '@atlassiansox/asc-stargate';

import { CrossFlowTouchpointProvider } from '@/components/cross-flow/touchpoint/context';
import { AvailableProductsResponse } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { IntercomProvider } from '@/libraries/intercom/src/provider';
import { ConfluenceSoftwarePageTemplate } from '@/templates/software/confluence/confluence-software-page/src/confluence-software-page.template';
import { BanditsUseCase } from '@/utils/anchor-queries/get-bandits-contents';
import { experiments } from '@/utils/experiment/manifest';
import { useExperimentExposure } from '@/utils/experiment/use-experiment-exposure';
import { JourneyLocalStoragePersona, useAnchorLocalStorage } from '@/utils/local-storage-hook.tsx';

import { AppPricingData } from '../../../../contentful/product-catalog';

import { isTargetedSubAnchor } from './subAnchors/subAnchor-util.tsx';

export type ConfluenceSoftwarePageProps = {
	pricing?: AppPricingData;
	availableProducts: AvailableProductsResponse | null;
	userProfile: MeResponse | null;
	keyword?: string;
	subAnchor?: string;
	useCase?: BanditsUseCase;
	utmMedium?: string;
	utmContent?: string;
	utmCampaign?: string;
};

export const ConfluenceSoftwarePage = (props: ConfluenceSoftwarePageProps) => {
	// FYI, this is currently JA only, since we only have JA work space appId
	const isBootIntercom: boolean = FeatureGates.checkGate('gwp-737-enable-intercom-chat-confluence');
	const [exposureSubAnchorFired, fireSubAnchorExposure] = useExperimentExposure(
		experiments.cfind4782LandingPageSubAnchorV3,
	);
	useEffect(() => {
		if (isTargetedSubAnchor(props.subAnchor) && !exposureSubAnchorFired) {
			fireSubAnchorExposure();
		}
	}, [exposureSubAnchorFired, fireSubAnchorExposure]);

	const { setAnchorLocalStorage } = useAnchorLocalStorage();
	useEffect(() => {
		const { keyword, subAnchor } = props;
		const anchorLocalStorage: JourneyLocalStoragePersona = {};
		if (!!keyword) {
			anchorLocalStorage.keyword = keyword;
		}
		if (!!subAnchor) {
			anchorLocalStorage.subAnchor = subAnchor;
		}
		if (Object.keys(anchorLocalStorage).length > 0) {
			setAnchorLocalStorage(anchorLocalStorage);
		}
	}, [props.keyword]);

	return (
		<IntercomProvider appId={'p0ww63i2'} triggerBoot={isBootIntercom}>
			<CrossFlowTouchpointProvider
				screenName="wacConfluenceProductTourPage"
				productKeys={[ProductKeys.CONFLUENCE]}
			>
				<ConfluenceSoftwarePageTemplate
					pricing={props.pricing}
					availableProducts={props.availableProducts}
					userProfile={props.userProfile}
					keyword={props.keyword}
					subAnchor={props.subAnchor}
					useCase={props.useCase}
					utmMedium={props.utmMedium}
					utmContent={props.utmContent}
					utmCampaign={props.utmCampaign}
				/>
			</CrossFlowTouchpointProvider>
		</IntercomProvider>
	);
};
